export default __webpack_public_path__ + "static/media/492.a943d17b.png";